export default {
  routeExtras: {
    extras: 'Extras de traseu',
    extraInfo: 'Informații suplimentare',
    value: 'Valoare',
    showAllOnMap: 'Arată totul pe hartă',
    clickToHighlightOnMap: 'Faceți clic pentru a-l evidenția pe hartă',
  }
}
